import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useStoreConfiguration } from '../configuration/configuration';
import { getRegion } from '../../api/region/region';
import type { RegionType } from '../../types/region';
import type { WindowWika } from '../../types/window';

export type StoreRegion = {
  items?: RegionType;
  language?: string;
};

const storeId = 'store-region';
const _window = window as unknown as WindowWika;

export const useStoreRegion = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();
  const regions = ref<StoreRegion>();

  async function fetchItems() {
    if (!storeConfiguration.config) {
      console.error(`${storeId} >>> error`, 'store configuration is not available');
      return;
    }

    const caasLanguage = storeConfiguration.caasConfig?.language.toLowerCase();

    const regionDataUrl =
      _window.instance === 'shop'
        ? storeConfiguration.config.pt_regions_shop_json.route
        : storeConfiguration.config.pt_regions_json.route;

    const items = await getRegion(regionDataUrl, storeId, caasLanguage);

    if (items) {
      regions.value = {
        items: { ...items.items },
        language: items.language,
      };
    }
  }

  watch(
    () => storeConfiguration.config,
    () => {
      if (storeConfiguration.config) {
        fetchItems();
      }
    },
    { immediate: true, deep: true },
  );

  return {
    regions,
  };
});
